import { render, staticRenderFns } from "./house-list.vue?vue&type=template&id=9c48ca3a&scoped=true&"
import script from "./house-list.vue?vue&type=script&lang=js&"
export * from "./house-list.vue?vue&type=script&lang=js&"
import style0 from "./house-list.vue?vue&type=style&index=0&id=9c48ca3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c48ca3a",
  null
  
)

export default component.exports